import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { EnvironmentConfig, ENV_CONFIG } from 'src/app/core/enviroment-config';
import { CrudApiService } from 'src/app/core/service/abstract/rest-api.service';
import { GPSFilePoints } from 'src/app/data/model/gps-address-data';
import { ApiModule } from '../api.module';

@Injectable({
  providedIn: ApiModule
})
export class GpsFilePointsApiService extends CrudApiService<GPSFilePoints> {
  constructor(http: HttpClient, @Inject(ENV_CONFIG) config: EnvironmentConfig) {
    super('resources/gps-file-points', http, config);
  }
}
